import React, { useEffect, useState } from "react";
import { Clock, Phone } from "lucide-react";
import { api } from "@/lib/api";

// #9 Out-of-hours operating banner. Sets clear expectations before/while a
// driver submits: outside staffed hours, non-urgent requests are recorded for
// the next working period; urgent assistance uses the OOH telephone route.
export function OpsStatusBanner({ compact = false }) {
  const [status, setStatus] = useState(null);
  useEffect(() => { api.opsStatus().then(setStatus).catch(() => setStatus(null)); }, []);
  if (!status || status.is_open) return null;
  return (
    <div
      data-testid="ooh-banner"
      className="rounded-[8px] border border-[hsl(var(--vda-amber))]/30 bg-[hsl(var(--vda-amber-bg))] px-4 py-3 mb-4"
    >
      <div className="flex items-start gap-2.5">
        <Clock className="h-4 w-4 mt-0.5 text-[hsl(var(--vda-amber))]" aria-hidden="true" />
        <div className="text-sm">
          <p className="font-medium text-foreground">
            The Venson team is currently outside staffed hours ({status.open}–{status.close}, working days).
          </p>
          {!compact && (
            <p className="text-muted-foreground mt-1">
              You can still record details now — non-urgent requests will be picked up from the next
              working period. For urgent assistance, use the out-of-hours route below.
            </p>
          )}
          {status.ooh_phone && (
            <a
              href={`tel:${status.ooh_phone.replace(/\s/g, "")}`}
              data-testid="ooh-call"
              className="mt-2 inline-flex items-center gap-1.5 text-sm font-medium text-primary"
            >
              <Phone className="h-3.5 w-3.5" /> {status.ooh_label || "Out-of-hours assistance"}: {status.ooh_phone}
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
